import React, { useState } from "react";
import "./DueDateChangeModal.css";

function fmt(d) {
  if (!d) return "—";
  const dt = typeof d === "string" ? new Date(d) : d;
  if (isNaN(dt)) return String(d);
  return dt.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
}

export default function DueDateChangeModal({ fromDate, toDate, onConfirm, onCancel }) {
  const [reason, setReason] = useState("");
  const [err, setErr] = useState("");

  function handleConfirm() {
    const trimmed = reason.trim();
    if (!trimmed) {
      setErr("Please provide a reason for the change.");
      return;
    }
    onConfirm(trimmed);
  }

  return (
    <div className="ddcm-scrim" onClick={onCancel}>
      <div className="ddcm-box" onClick={(e) => e.stopPropagation()}>
        <div className="ddcm-header">
          <span className="ddcm-title">Due Date Changed</span>
        </div>
        <div className="ddcm-body">
          <div className="ddcm-dates">
            <div className="ddcm-date-item">
              <span className="ddcm-date-label">From</span>
              <span className="ddcm-date-val ddcm-date-val--old">{fmt(fromDate)}</span>
            </div>
            <span className="ddcm-arrow">→</span>
            <div className="ddcm-date-item">
              <span className="ddcm-date-label">To</span>
              <span className="ddcm-date-val ddcm-date-val--new">{fmt(toDate)}</span>
            </div>
          </div>
          <label className="ddcm-label">Reason <span className="ddcm-required">*</span></label>
          <textarea
            className={`ddcm-textarea${err ? " ddcm-textarea--err" : ""}`}
            rows={3}
            placeholder="Explain why the due date is being changed…"
            value={reason}
            onChange={(e) => { setReason(e.target.value); setErr(""); }}
            autoFocus
          />
          {err && <span className="ddcm-err">{err}</span>}
        </div>
        <div className="ddcm-footer">
          <button className="ddcm-cancel" onClick={onCancel}>Cancel</button>
          <button className="ddcm-confirm" onClick={handleConfirm}>Confirm</button>
        </div>
      </div>
    </div>
  );
}
